import { ArrowUpload20Regular, Document20Regular } from '@/components/Icon'

export const ATTACH_MENU_ITEM_IDS = {
  DOCUMENTS: 'attach-from-documents',
  UPLOAD: 'attach-upload',
}

export const ATTACH_MENU_ITEMS = [
  {
    id: ATTACH_MENU_ITEM_IDS.DOCUMENTS,
    label: 'Select from Documents',
    Icon: Document20Regular,
  },
  {
    id: ATTACH_MENU_ITEM_IDS.UPLOAD,
    label: 'Upload',
    Icon: ArrowUpload20Regular,
  },
]
